import { createAuthClient } from "better-auth/react";
import { adminClient, inferAdditionalFields, magicLinkClient } from "better-auth/client/plugins";
import { env } from "@/lib/env";
import { clearAuthToken } from "@/lib/auth-token";

/**
 * Better Auth client for the admin site, pointed at the same @ensoo/auth
 * service as the learner app. Ban, unban and role changes go to its
 * /admin/* endpoints; everything else admin-shaped goes through the
 * gateway's oRPC admin module with the minted bearer JWT.
 */
export const authClient = createAuthClient({
  baseURL: env.ADMIN__AUTH_URL,
  plugins: [
    magicLinkClient(),
    adminClient(),
    // Mirrored by hand from `user.additionalFields` in apps/auth/src/lib/auth.ts.
    inferAdditionalFields({
      user: {
        phone: { type: "string", required: false },
        profileCompleted: { type: "boolean", required: false },
        birthYear: { type: "number", required: false },
        country: { type: "string", required: false },
        countrySource: { type: "string", required: false },
      },
    }),
  ],
  fetchOptions: {
    credentials: "include",
    onResponse: (ctx) => {
      if (String(ctx.request.url).includes("/api/auth/sign-out")) clearAuthToken();
    },
  },
});

export const { signIn, signOut, useSession } = authClient;

/** Shown on the role claim; the gateway enforces it on every call. */
export function isAdmin(user: { role?: string | null } | undefined | null): boolean {
  return user?.role === "admin";
}
